<template>
  <div>
    <VaModal
      v-model="showSuggestionModal"
      size="medium"
      hide-default-actions
      overlay-opacity="0.2"
      blur
      @clickOutside="modalClosed()"
    >
      <template #header>
        <div>
          <p class="font-normal text-lg">Set alerts for your domain</p>
        </div>
        <div class="w-full d-flex justify-center mt-11">
          <Search :alert-suggestion="true" @alertSetEmit="toggleSuggestionAlertModal()"></Search>
        </div>
      </template>
      <template #footer>
        <div>
          <VaButton class="mt-12 mr-8 text-white" color="#F87171" @click="close()">
            <span class="text-white">Cancel</span></VaButton
          >
        </div>
      </template>
    </VaModal>
  </div>
</template>
<script setup>
import { ref } from 'vue'
import Search from './Search.vue'

const showSuggestionModal = ref(false)

const toggleSuggestionAlertModal = () => {
  localStorage.setItem('alertPopUp', 'true')
  showSuggestionModal.value = !showSuggestionModal.value
}

const close = () => {
  showSuggestionModal.value = !showSuggestionModal.value
}

defineExpose({
  toggleSuggestionAlertModal,
})
</script>
